import React from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";

import CashOutService from "../../../services/Celcoin/dinamicCashOutService";
import SideMenu from "../../../components/SideMenu";
import Footer from "../../../components/Footer";
import Quotes from "../../../components/Quotes";
import Table from "../../../components/Account/Table";
import SlideOver from "../../../components/Account/SlideOver";
import MtBankCharts from "../../../components/Account/Chart";

import AccountManagerService from "../../../services/Celcoin/accountManagerService";
import { getTranslations } from "../../../services/languageUtils";
import { isMutual } from "../../../utils/isMutual";
import { isMtBank } from "../../../utils/isMtBank";
import { isVoluti } from "../../../utils/isVoluti";

import logo from "../../../assets/imgs/logo_new.png";
import logoPmi from "../../../assets/imgs/PMI.png";

let localThat = "this";

class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      translations: {},
      currentPage: 1,
      totalPages: 1,
      open: false,
      filterDays: "7day",
      openDataRangeDialog: false,
      startRangeDate: this.formatCalendarDate(new Date()),
      endRangeDate: this.formatCalendarDate(new Date()),
      search: "",
      item: {
        id: "",
        amount: 0.0,
        clientCode: "",
        transactionIdentification: null,
        endToEndId: "",
        initiationType: "",
        paymentType: "",
        urgency: "",
        transactionType: "",
        debitParty: {
          account: "",
          branch: "",
          taxId: "",
          name: "",
          accountType: "",
        },
        creditParty: {
          bank: "",
          key: "",
          account: "",
          branch: "",
          taxId: "",
          name: "",
          accountType: "",
        },
        remittanceInformation: "",
        error: null,
      },
      list: [],
      filteredList: [],
      valueBalance: 0.0,
      viewBalance: false,
      disableDownload: false,
      disableDownload1: false,
      disableDownload2: false,
    };

    localThat = this;
    this.contentScrollRef = React.createRef();
  }

  formatCalendarDate(date) {
    return date.toISOString().split("T")[0];
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  setOpen(value, item) {
    if (value) {
      localThat.setState({ item: item }, () => {
        localThat.setState({ open: value });
      });
    } else {
      localThat.setState({ open: value });
    }
  }

  selectRangeDate() {
    let that = this;
    this.setState({ openDataRangeDialog: false }, () => {
      that.refresh();
    });
  }

  componentDidMount() {
    this.loadTranslations();
    this.refresh();
    this.getBalance();
  }

  getBalance() {
    const that = this;
    AccountManagerService.showBalance()
      .then((res) => {
        that.setState({ valueBalance: res.data.body.amount });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  formatDate(date) {
    const d = new Date(date);
    d.setUTCHours(0, 0, 0, 0);
    return d.toISOString();
  }

  /**
   * Fim do período consultado.
   *
   * Nas contas BaaS/Mutual a consulta passou a respeitar a hora, então o período
   * termina no último instante do dia escolhido. O "+1 dia" que existia aqui era
   * a forma de não perder o último dia quando só a data era enviada — e fazia a
   * tela pedir sempre uma data fora do período selecionado (escolher "3 Dias" em
   * 31/08 mandava endDate=2026-09-01).
   *
   * Os demais bancos continuam recebendo exatamente o que recebiam antes.
   */
  formatPeriodEnd(date) {
    const d = new Date(date);

    if (isMutual()) {
      d.setUTCHours(23, 59, 59, 999);
      return d.toISOString();
    }

    d.setDate(d.getDate() + 1);
    return this.formatDate(d);
  }

  formatDateTime(input) {
    const date = new Date(input);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month} - ${hours}:${minutes}:${seconds}`;
  }

  refresh(custom) {
    const currentDate = new Date();
    let dateFrom,
      dateTo,
      page = this.state.currentPage;
    const subDays = (days) => {
      const date = new Date(currentDate);
      date.setDate(date.getDate() - days);
      return date;
    };

    switch (this.state.filterDays) {
      case "7day":
        dateFrom = subDays(7);
        break;
      case "15day":
        dateFrom = subDays(15);
        break;
      case "25day":
        dateFrom = subDays(25);
        break;
      case "range":
        dateFrom = new Date(`${this.state.startRangeDate}T00:00:00`);
        dateTo = new Date(`${this.state.endRangeDate}T00:00:00`);
        break;
      default:
        dateFrom = subDays(0);
    }

    dateFrom = this.formatDate(dateFrom);
    dateTo = this.formatPeriodEnd(dateTo || currentDate);

    const that = this;
    if (isMutual()) {
      AccountManagerService.showStatement({
        email: sessionStorage.getItem("emailUser"),
        startDate: dateFrom,
        endDate: dateTo,
        offset: page - 1,
        limit: 100,
      })
        .then((res) => {
          if (that.contentScrollRef.current) {
            that.contentScrollRef.current.scrollTop = 0;
          }

          const list = Array.isArray(res?.data?.data) ? res.data.data : [];
          const limit = Number(res?.data?.meta?.limit || 100);
          const totalFromApi = Number(res?.data?.meta?.total);
          const isFirstPage = page <= 1;
          const computedTotalPages =
            isFirstPage && list.length < limit
              ? 1
              : Number.isFinite(totalFromApi) && totalFromApi > 0
                ? parseInt(Math.ceil(totalFromApi / limit))
                : 1;

          that.setState(
            {
              list,
              totalPages: Math.max(computedTotalPages, 1),
            },
            () => {
              that.refreshFilter();
            },
          );
        })
        .catch((err) => {
          console.error(err);
          that.setState({ list: [] }, () => {
            that.refreshFilter();
          });
          return that.toastMessage(
            "error",
            this.state.translations.weDidNotFindAnyReleasesFor,
          );
        });
    } else if (isMtBank() || isVoluti()) {
      let search = {
        email: sessionStorage.getItem("emailUser"),
        offset: page - 1,
        startDate: dateFrom,
        endDate: dateTo,
        endtoendid: "1",
        limit: 100,
      };

      AccountManagerService.showStatement(search)
        .then((res) => {
          if (that.contentScrollRef.current) {
            that.contentScrollRef.current.scrollTop = 0;
          }
          if (!isVoluti()) {
            const transactions = res.data.transactions || [];
            const totalTransactions =
              res.data.transactions_total || transactions.length;

            that.setState(
              {
                list: transactions,
                totalPages: parseInt(Math.ceil(totalTransactions / 100)),
              },
              () => {
                that.refreshFilter();
              },
            );
          } else {
            that.setState(
              {
                list: res.data.data,
                totalPages: res.data.count,
              },
              () => {
                that.refreshFilter();
              },
            );
          }
        })
        .catch((err) => {
          console.error(err);
          that.setState({ list: [] }, () => {
            that.refreshFilter();
          });
          return that.toastMessage(
            "error",
            this.state.translations.weDidNotFindAnyReleasesFor,
          );
        });
    } else {
      AccountManagerService.showMovement({ dateFrom, dateTo, page })
        .then((res) => {
          if (that.contentScrollRef.current) {
            that.contentScrollRef.current.scrollTop = 0;
          }
          that.setState(
            {
              list: res.data.body.movements,
              totalPages: res.data.totalPages,
            },
            () => {
              that.refreshFilter();
            },
          );
        })
        .catch((err) => {
          console.error(err);
          that.setState({ list: [] }, () => {
            that.refreshFilter();
          });
          return that.toastMessage(
            "error",
            this.state.translations.weDidNotFindAnyReleasesFor,
          );
        });
    }
  }

  refreshFilter() {
    let that = this;
    let list = this.state.list;
    this.setState({ load: false }, () => {
      that.setState({
        filteredList: list,
      });
    });
  }

  toastMessage(type, message) {
    switch (type) {
      case "success":
        return toast(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
          theme: "light",
        });
      default:
        return toast(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
          theme: "light",
        });
    }
  }

  formatToBRL(number) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(number);
  }

  filterTextSearch(item, that) {
    try {
      if (
        document.getElementById("search").value === "" ||
        item.status
          .toLowerCase()
          .search(document.getElementById("search").value.toLowerCase()) !==
          -1 ||
        this.formatToBRL(item.amount)
          .toLowerCase()
          .search(document.getElementById("search").value.toLowerCase()) !== -1
      )
        return true;
      return false;
    } catch (err) {
      return true;
    }
  }

  extractItemsFromStatementResponse(res) {
    const data = res && res.data ? res.data : [];
    if (Array.isArray(data)) return data;
    if (Array.isArray(data.transactions)) return data.transactions;
    if (Array.isArray(data.data)) return data.data;
    if (data && Array.isArray(data.items)) return data.items;
    return [];
  }

  generateCSV = () => {
    this.setState({ disableDownload: true });

    const currentDate = new Date();
    let dateFrom, dateTo;
    const subDays = (days) => {
      const date = new Date(currentDate);
      date.setDate(date.getDate() - days);
      return date;
    };

    switch (this.state.filterDays) {
      case "7day":
        dateFrom = subDays(7);
        break;
      case "15day":
        dateFrom = subDays(15);
        break;
      case "25day":
        dateFrom = subDays(25);
        break;
      case "range":
        dateFrom = new Date(`${this.state.startRangeDate}T00:00:00`);
        dateTo = new Date(`${this.state.endRangeDate}T00:00:00`);
        break;
      default:
        dateFrom = subDays(0);
    }

    dateFrom = this.formatDate(dateFrom);
    dateTo = this.formatPeriodEnd(dateTo || currentDate);

    const params = {
      email: sessionStorage.getItem("emailUser"),
      startDate: dateFrom,
      endDate: dateTo,
      limit: 1000000,
      offset: 0,
      filter: "",
    };

    AccountManagerService.showStatement(params)
      .then((res) => {
        const items = this.extractItemsFromStatementResponse(res);
        if (!items || items.length === 0) {
          return this.toastMessage(
            "error",
            this.state.translations.weDidNotFindAnyReleasesFor ||
              "Nenhum dado encontrado para o período selecionado.",
          );
        }
        this.downloadCSVMtBank(items);
      })
      .catch(() => {
        return this.toastMessage(
          "error",
          this.state.translations.errorGeneratingCSV || "Erro ao gerar o CSV",
        );
      })
      .finally(() => {
        this.setState({ disableDownload: false });
      });
  };

  downloadCSV(csv) {
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const filename = `historico_${new Date().toISOString()}.csv`;
      link.setAttribute("href", URL.createObjectURL(blob));
      link.setAttribute("download", filename);
      link.click();
    }
  }

  downloadCSVMtBank(list) {
    if (!Array.isArray(list) || list.length === 0) {
      alert("Nenhum dado disponível para exportação.");
      return;
    }

    const allKeys = Array.from(
      new Set(list.flatMap((obj) => Object.keys(obj))),
    );

    const header = allKeys.join(",");

    const rows = list.map((item) =>
      allKeys
        .map((key) => {
          const val = item[key];
          if (val === null || val === undefined) return "";
          return `"${String(val).replace(/"/g, '""')}"`;
        })
        .join(","),
    );

    const csvContent = [header, ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const filename = `historico_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}.csv`;

    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", filename);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  generateXLSX = () => {
    this.setState({ disableDownload1: true });
    if (!this.state.disableDownload1) {
      const currentDate = new Date();
      let dateFrom, dateTo;
      const subDays = (days) => {
        const date = new Date(currentDate);
        date.setDate(date.getDate() - days);
        return date;
      };

      switch (this.state.filterDays) {
        case "7day":
          dateFrom = subDays(7);
          break;
        case "15day":
          dateFrom = subDays(15);
          break;
        case "25day":
          dateFrom = subDays(25);
          break;
        case "range":
          dateFrom = new Date(`${this.state.startRangeDate}T00:00:00`);
          dateTo = new Date(`${this.state.endRangeDate}T00:00:00`);
          break;
        default:
          dateFrom = subDays(0);
      }

      dateFrom = this.formatDate(dateFrom);
      dateTo = this.formatPeriodEnd(dateTo || currentDate);

      const params = {
        email: sessionStorage.getItem("emailUser"),
        startDate: dateFrom,
        endDate: dateTo,
        limit: 1000000,
        offset: 0,
        filter: "",
      };

      AccountManagerService.showStatement(params)
        .then((res) => {
          const items = this.extractItemsFromStatementResponse(res);

          if (!items || items.length === 0) {
            return this.toastMessage(
              "error",
              "Nenhum dado encontrado para o período selecionado.",
            );
          }

          this.downloadXLSX(items);
        })
        .catch(() => {
          this.toastMessage("error", "Erro ao gerar o Excel");
        })
        .finally(() => {
          this.setState({ disableDownload1: false });
        });
    }
  };

  downloadXLSX(list) {
    if (!Array.isArray(list) || list.length === 0) {
      alert("Nenhum dado disponível para exportação.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(list);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Histórico");

    const filename = `historico_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-")}.xlsx`;
    XLSX.writeFile(wb, filename);
  }

  generatePDF = () => {
    this.setState({ disableDownload2: true });
    if (!this.state.disableDownload2) {
      const currentDate = new Date();
      let dateFrom, dateTo;
      const subDays = (days) => {
        const date = new Date(currentDate);
        date.setDate(date.getDate() - days);
        return date;
      };

      switch (this.state.filterDays) {
        case "7day":
          dateFrom = subDays(7);
          break;
        case "15day":
          dateFrom = subDays(15);
          break;
        case "25day":
          dateFrom = subDays(25);
          break;
        case "range":
          dateFrom = new Date(`${this.state.startRangeDate}T00:00:00`);
          dateTo = new Date(`${this.state.endRangeDate}T00:00:00`);
          break;
        default:
          dateFrom = subDays(0);
      }

      dateFrom = this.formatDate(dateFrom);
      dateTo = this.formatPeriodEnd(dateTo || currentDate);

      const params = {
        email: sessionStorage.getItem("emailUser"),
        startDate: dateFrom,
        endDate: dateTo,
        limit: 1000000,
        offset: 0,
        filter: "",
      };

      AccountManagerService.showStatement(params)
        .then((res) => {
          const items = this.extractItemsFromStatementResponse(res);

          if (!items || items.length === 0) {
            return this.toastMessage(
              "error",
              "Nenhum dado encontrado para o período selecionado.",
            );
          }
          this.downloadPDF(items);
        })
        .catch(() => {
          this.toastMessage("error", "Erro ao gerar o PDF");
        })
        .finally(() => {
          this.setState({ disableDownload2: false });
        });
    }
  };

  async downloadPDF(list) {
    if (!Array.isArray(list) || list.length === 0) {
      alert("Nenhum dado disponível para exportação.");
      return;
    }

    const detalhes = await Promise.all(
      list.map(async (tx) => {
        try {
          if (tx.type?.toUpperCase() === "DEBIT") {
            const res = await CashOutService.showPayment({ id: tx.reference });
            const d = res.data;

            return {
              ...tx,
              pagador: d.sender_account?.name ?? "—",
              pagadorDoc: d.sender_account?.cpf_cnpj ?? "—",
              pagadorBanco: d.sender_account?.bank ?? "—",
              pagadorAgencia: d.sender_account?.bank_agency ?? "—",
              pagadorConta: d.sender_account?.bank_account ?? "—",

              beneficiario: d.receiver_account?.name ?? "—",
              beneficiarioDoc: d.receiver_account?.cpf_cnpj ?? "—",
              beneficiarioBanco:
                (d.receiver_account?.compe ?? "") +
                " " +
                (d.receiver_account?.bank ?? ""),
              beneficiarioAgencia: d.receiver_account?.bank_agency ?? "—",
              beneficiarioConta: d.receiver_account?.bank_account ?? "—",
            };
          }

          return {
            ...tx,
            pagador: tx.payer_name ?? "—",
            pagadorDoc: tx.customer_ref ?? "—",
            pagadorBanco: tx.bank ?? "—",
            pagadorAgencia: tx.agency ?? "—",
            pagadorConta: tx.account ?? "—",

            beneficiario: tx.customer_name ?? "—",
            beneficiarioDoc: tx.customer_ref ?? "—",
            beneficiarioBanco: tx.bank ?? "—",
            beneficiarioAgencia: tx.agency ?? "—",
            beneficiarioConta: tx.account ?? "—",
          };
        } catch (err) {
          return {
            ...tx,
            pagador: "—",
            pagadorDoc: "—",
            pagadorBanco: "—",
            pagadorAgencia: "—",
            pagadorConta: "—",

            beneficiario: "—",
            beneficiarioDoc: "—",
            beneficiarioBanco: "—",
            beneficiarioAgencia: "—",
            beneficiarioConta: "—",
          };
        }
      }),
    );

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a3",
    });

    const isPMI = sessionStorage.getItem("emailUser").includes("@pmi.tech");
    const empresaNome = isPMI
      ? "PMI AMERICAS"
      : "Higher Meios de Pagamentos LTDA";

    const empresaLogo = isPMI ? logoPmi : logo;

    const addHeader = (pageNumber = 1) => {
      const imgWidth = 25;
      const imgHeight = 15;
      const imgX = 14;
      const headerY = 10;

      doc.addImage(empresaLogo, "PNG", imgX, headerY, imgWidth, imgHeight);

      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text(empresaNome, imgX + imgWidth + 5, headerY + 10);

      if (pageNumber === 1) {
        doc.setFontSize(11);
        doc.setFont("helvetica", "normal");

        const geração = new Date();
        const dataGerada =
          geração.toLocaleDateString("pt-BR") +
          " " +
          geração.toLocaleTimeString("pt-BR");

        doc.text(
          `De ${this.state.startRangeDate} 00:00:00 até ${this.state.endRangeDate} 23:59:59 - Gerado em ${dataGerada}`,
          14,
          headerY + 22,
        );
      }
    };

    addHeader(1);

    let totalEstorno = 0;
    let totalCredito = 0;
    let totalDebito = 0;

    detalhes.forEach((tx) => {
      const value = parseFloat(tx.amount_cents);

      if (tx.type !== "debit") totalCredito += value;
      if (tx.description === "Estorno de Transferência") totalEstorno += value;
      if (tx.type === "debit") totalDebito += Math.abs(value);
    });

    const last = detalhes[detalhes.length - 1];
    const saldoAnterior =
      (Number(last.balance_cents) - Number(last.amount_cents)) / 100;

    const resumoTable = [
      {
        descricao: "Saldo Anterior",
        valor: `R$ ${saldoAnterior.toFixed(2)}`,
        data: last.entry_date,
      },
      {
        descricao: "Créditos (+)",
        valor: `R$ ${(totalCredito / 100).toFixed(2)}`,
        data: "",
      },
      {
        descricao: "Estornos (+)",
        valor: `R$ ${(totalEstorno / 100).toFixed(2)}`,
        data: "",
      },
      {
        descricao: "Débitos (-)",
        valor: `R$ ${(totalDebito / 100).toFixed(2)}`,
        data: "",
      },
      {
        descricao: "Saldo em Conta",
        valor: `R$ ${this.state.valueBalance}`,
        data: "",
      },
    ];

    doc.setFontSize(14);
    doc.text("RESUMO DAS OPERAÇÕES", 14, 45);

    doc.autoTable({
      startY: 50,
      head: [["Descrição", "Valor", "Data"]],
      body: resumoTable.map((r) => [r.descricao, r.valor, r.data]),
      styles: { fontSize: 10 },
      headStyles: { fillColor: [80, 80, 80] },
    });

    doc.addPage();
    addHeader(2);

    doc.setFontSize(14);
    doc.text("EXTRATO DE TRANSAÇÕES", 14, 40);

    const isDebitAmount = (tx) =>
      Number(tx?.amount_cents ?? tx?.amount ?? 0) < 0;

    const transacoesTable = detalhes.map((tx) => [
      tx.transaction_type === "deposit" ||
      (tx.transaction_type === "misc" && tx.type === "credit")
        ? tx.description
        : (tx.pagador ?? "—"),
      isDebitAmount(tx)
        ? (tx.beneficiario ?? "--")
        : sessionStorage.getItem("nameUser"),
      tx.transaction_type === "misc" ? "Transferência interna" : "PIX",
      tx.description === "Estorno de Transferência"
        ? "Estorno"
        : isDebitAmount(tx)
          ? "Pago"
          : "Recebido",
      String(tx.pagadorDoc || "").includes("@") ? "—" : (tx.pagadorDoc ?? "—"),
      tx.pagadorAgencia ?? "—",
      tx.pagadorConta ?? "—",
      tx.reference ?? "—",
      `R$ ${(Number(tx.amount_cents) / 100).toFixed(2)}`,
    ]);

    let currentPage = 2;

    doc.autoTable({
      startY: 45,
      head: [
        [
          "Pagador",
          "Beneficiário",
          "Tipo",
          "Status",
          "Documento",
          "Agência",
          "Conta",
          "Referência",
          "Valor",
        ],
      ],
      body: transacoesTable,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [80, 80, 80] },
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 40 },
        2: { cellWidth: 20 },
        3: { cellWidth: 25 },
        4: { cellWidth: 35 },
        5: { cellWidth: 20 },
        6: { cellWidth: 25 },
        7: { cellWidth: 25 },
        8: { cellWidth: 25 },
      },
      didDrawPage: (data) => {
        currentPage++;
        if (currentPage <= 2) addHeader(currentPage);

        if (currentPage === 2) {
          doc.setFontSize(14);
          doc.text("EXTRATO DE TRANSAÇÕES", 14, 40);
        }
      },
    });

    const filename = `historico_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}.pdf`;

    doc.save(filename);
  }

  /**
   * Atualiza um lado do intervalo do filtro "Data".
   *
   * Os dois campos são independentes na tela, então o usuário pode escolher um
   * fim anterior ao início (ou vice-versa). Um período invertido não retorna
   * nada — em vez de deixar a consulta sair quebrada, o outro lado acompanha.
   */
  updateDate(type, value) {
    if (!value) return;

    if (type === "finish") {
      this.setState((state) => ({
        endRangeDate: value,
        startRangeDate:
          state.startRangeDate > value ? value : state.startRangeDate,
      }));
      return;
    }

    this.setState((state) => ({
      startRangeDate: value,
      endRangeDate: state.endRangeDate < value ? value : state.endRangeDate,
    }));
  }

  updateCurrentPage(page) {
    this.setState({ currentPage: page }, () => {
      if (page !== "") this.refresh();
    });
  }

  render() {
    return (
      <section id="userPage" className="userPage transactionPage statementPage">
        <SideMenu />
        {window.screen.width > 720 && (
          <span className="desktop">
            <div className="contentData">
              <div className="contentScroll" ref={this.contentScrollRef}>
                <Quotes />
                <p className="breadcrumb">
                  <b>
                    <span className="textPrimary">
                      {this.state.translations.home} |{" "}
                      {this.state.translations.account}
                    </span>{" "}
                    | {this.state.translations.statement}
                  </b>
                </p>
                <br />
                <p className="title">
                  <span style={{ fontWeight: "normal" }}>
                    {this.state.translations.account} |
                  </span>{" "}
                  {this.state.translations.statement}
                </p>
                <br />

                <div className="contentSubData">
                  <div
                    onClick={() => {
                      let that = this;
                      this.setState(
                        { filterDays: "7day", openDataRangeDialog: false },
                        () => {
                          that.refresh();
                        },
                      );
                    }}
                    className={
                      "item " +
                      (this.state.filterDays === "7day" ? "itemSelected" : "")
                    }
                  >
                    {this.state.translations.sevenDays}
                  </div>
                  <div
                    onClick={() => {
                      let that = this;
                      this.setState(
                        { filterDays: "15day", openDataRangeDialog: false },
                        () => {
                          that.refresh();
                        },
                      );
                    }}
                    className={
                      "item " +
                      (this.state.filterDays === "15day" ? "itemSelected" : "")
                    }
                  >
                    {this.state.translations.fifteenDays}
                  </div>
                  <div
                    onClick={() => {
                      let that = this;
                      this.setState(
                        { filterDays: "25day", openDataRangeDialog: false },
                        () => {
                          that.refresh();
                        },
                      );
                    }}
                    className={
                      "item " +
                      (this.state.filterDays === "25day" ? "itemSelected" : "")
                    }
                  >
                    {this.state.translations.thirtyDays}
                  </div>
                  <div
                    className={
                      "item " +
                      (this.state.filterDays === "range" ? "itemSelected" : "")
                    }
                  >
                    <span
                      onClick={() => {
                        this.setState({
                          filterDays: "range",
                          openDataRangeDialog: !this.state.openDataRangeDialog,
                        });
                      }}
                    >
                      {this.state.translations.rangePeriod}
                    </span>
                    {this.state.filterDays === "range" &&
                      this.state.openDataRangeDialog && (
                        <div className="contentRangeDate">
                          <input
                            type="date"
                            id="start"
                            aria-label="Data inicial"
                            title="Data inicial"
                            value={this.state.startRangeDate}
                            onChange={(e) => {
                              this.updateDate("start", e.target.value);
                            }}
                          />
                          <input
                            type="date"
                            id="finish"
                            aria-label="Data final"
                            title="Data final"
                            min={this.state.startRangeDate}
                            value={this.state.endRangeDate}
                            onChange={(e) => {
                              this.updateDate("finish", e.target.value);
                            }}
                          />
                          <div
                            className="btnRangeDate"
                            role="button"
                            title="Aplicar período"
                            aria-label="Aplicar período"
                            onClick={() => this.selectRangeDate()}
                          >
                            <CheckIcon className="rangeDateIcon" aria-hidden="true" />
                          </div>
                        </div>
                      )}
                  </div>

                  <button
                    onClick={this.generateCSV}
                    className="item itemSelected"
                    disabled={this.state.disableDownload}
                  >
                    {this.state.disableDownload ? (
                      <span className="spinner" />
                    ) : (
                      this.state.translations.downloadCSV
                    )}
                  </button>
                  <button
                    onClick={this.generatePDF}
                    className="item itemSelected"
                    disabled={this.state.disableDownload2}
                  >
                    {this.state.disableDownload2 ? (
                      <span className="spinner" />
                    ) : (
                      "Download PDF"
                    )}
                  </button>
                  <button
                    onClick={this.generateXLSX}
                    className="item itemSelected"
                    disabled={this.state.disableDownload1}
                  >
                    {this.state.disableDownload1 ? (
                      <span className="spinner" />
                    ) : (
                      "Download XLSX"
                    )}
                  </button>
                  {
                    // <input type="text" className="inputSearch" autoComplete="name" id="search" placeholder={this.state.translations.searchByValueOrStatus} onChange={()=> {
                    //   const that = this;
                    //   this.setState({currentPage: 1}, () => {
                    //       that.refresh();
                    //     });
                    //   }
                    //   } />
                  }
                  <SlideOver
                    setOpen={this.setOpen}
                    open={this.state.open}
                    item={this.state.item}
                  />

                  <Table
                    list={this.state.filteredList}
                    setOpen={this.setOpen}
                  />

                  <div className="pagination">
                    <button
                      disabled={this.state.currentPage === 1}
                      onClick={() =>
                        this.setState({ currentPage: 1 }, () => this.refresh())
                      }
                    >
                      {this.state.translations.first}
                    </button>
                    <button
                      disabled={this.state.currentPage === 1}
                      onClick={() =>
                        this.setState(
                          { currentPage: Number(this.state.currentPage) - 1 },
                          () => this.refresh(),
                        )
                      }
                    >
                      {this.state.translations.previous}
                    </button>
                    <span>
                      {this.state.translations.page}
                      <input
                        type="number"
                        value={this.state.currentPage}
                        onChange={(e) =>
                          this.setState({ currentPage: e.target.value })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.updateCurrentPage(e.target.value);
                          }
                        }}
                        className="inputPage"
                      />
                    </span>{" "}
                    de {this.state.totalPages}
                    <button
                      onClick={() =>
                        this.setState(
                          { currentPage: Number(this.state.currentPage) + 1 },
                          () => this.refresh(),
                        )
                      }
                    >
                      {this.state.translations.next}
                    </button>
                    <button
                      disabled={
                        this.state.currentPage === this.state.totalPages
                      }
                      onClick={() => {
                        const that = this;
                        this.setState(
                          { currentPage: that.state.totalPages },
                          () => this.refresh(),
                        );
                      }}
                    >
                      {this.state.translations.last}
                    </button>
                  </div>
                  <br />
                  <br />
                  <br />
                  {isMtBank() && (
                    <div style={{ marginBottom: "40px" }}>
                      <MtBankCharts data={this.state.filteredList} />
                    </div>
                  )}
                </div>

                <Footer />
              </div>
            </div>
          </span>
        )}
        {window.screen.width <= 720 && (
          <span className="mobile">
            <div className="contentData">
              <div className="contentScroll" ref={this.contentScrollRef}>
                <div
                  style={{
                    padding: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span>{this.state.translations.currentBalance}</span>
                  <span style={{ fontSize: "20px" }}>
                    <b>
                      {this.state.viewBalance
                        ? Number(
                            this.state.valueBalance.toFixed(2),
                          ).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })
                        : "**********"}{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                    </b>
                    {this.state.viewBalance && (
                      <img
                        src={
                          require("../../../assets/imgs/open-eye.svg").default
                        }
                        style={{ display: "inline-block", cursor: "pointer" }}
                        alt={this.state.translations.viewBalanceIcon}
                        onClick={() => {
                          this.setState({ viewBalance: false });
                        }}
                      />
                    )}
                    {!this.state.viewBalance && (
                      <img
                        src={
                          require("../../../assets/imgs/close-eye.svg").default
                        }
                        style={{
                          border: "3px solid rgba(0,0,0,0)",
                          display: "inline-block",
                          cursor: "pointer",
                        }}
                        alt={this.state.translations.hideBalanceIcon}
                        onClick={() => {
                          this.setState({ viewBalance: true });
                        }}
                      />
                    )}
                  </span>
                </div>

                <p className="title" style={{ marginTop: "20px" }}>
                  {this.state.translations.account} |
                  <span style={{ fontWeight: "normal" }}>
                    {" "}
                    {this.state.translations.statement}
                  </span>
                </p>
                <br />

                <div className="contentSubData">
                  <input
                    type="text"
                    className="inputSearch"
                    autoComplete="name"
                    id="search"
                    placeholder={this.state.translations.searchByValueOrStatus}
                    onChange={() => this.refreshFilter()}
                  />

                  <div
                    style={{
                      display: "block",
                      margin: "20px auto",
                      width: "fit-content",
                    }}
                  >
                    <div
                      onClick={() => {
                        let that = this;
                        this.setState(
                          { filterDays: "7day", openDataRangeDialog: false },
                          () => {
                            that.refresh();
                          },
                        );
                      }}
                      className={
                        "item " +
                        (this.state.filterDays === "7day" ? "itemSelected" : "")
                      }
                    >
                      {this.state.translations.sevenDaysAbbreviated}
                    </div>
                    <div
                      onClick={() => {
                        let that = this;
                        this.setState(
                          { filterDays: "15day", openDataRangeDialog: false },
                          () => {
                            that.refresh();
                          },
                        );
                      }}
                      className={
                        "item " +
                        (this.state.filterDays === "15day"
                          ? "itemSelected"
                          : "")
                      }
                    >
                      {this.state.translations.fifteenDaysAbbreviated}
                    </div>
                    <div
                      onClick={() => {
                        let that = this;
                        this.setState(
                          { filterDays: "25day", openDataRangeDialog: false },
                          () => {
                            that.refresh();
                          },
                        );
                      }}
                      className={
                        "item " +
                        (this.state.filterDays === "25day"
                          ? "itemSelected"
                          : "")
                      }
                    >
                      {this.state.translations.thirtyDaysAbbreviated}
                    </div>
                    <div
                      className={
                        "item " +
                        (this.state.filterDays === "range"
                          ? "itemSelected"
                          : "")
                      }
                    >
                      <span
                        onClick={() => {
                          this.setState({
                            filterDays: "range",
                            openDataRangeDialog:
                              !this.state.openDataRangeDialog,
                          });
                        }}
                      >
                        {this.state.translations.rangeSymbol}
                      </span>
                      {this.state.filterDays === "range" &&
                        this.state.openDataRangeDialog && (
                          <div className="contentRangeDate">
                            <input
                              type="date"
                              id="start"
                              aria-label="Data inicial"
                              title="Data inicial"
                              value={this.state.startRangeDate}
                              onChange={(e) => {
                                this.updateDate("start", e.target.value);
                              }}
                            />
                            <input
                              type="date"
                              id="finish"
                              aria-label="Data final"
                              title="Data final"
                              min={this.state.startRangeDate}
                              value={this.state.endRangeDate}
                              onChange={(e) => {
                                this.updateDate("finish", e.target.value);
                              }}
                            />
                            <div
                              className="btnRangeDate"
                              role="button"
                              title="Aplicar período"
                              aria-label="Aplicar período"
                              onClick={() => this.selectRangeDate()}
                            >
                              <CheckIcon className="rangeDateIcon" aria-hidden="true" />
                            </div>
                          </div>
                        )}
                    </div>

                    <button
                      onClick={this.generateCSV}
                      className="item itemSelected"
                      disabled={this.state.disableDownload}
                    >
                      {this.state.disableDownload ? (
                        <span className="spinner" />
                      ) : (
                        this.state.translations.downloadCSV
                      )}
                    </button>
                    <button
                      onClick={this.generatePDF}
                      className="item itemSelected"
                      disabled={this.state.disableDownload2}
                    >
                      {this.state.disableDownload2 ? (
                        <span className="spinner" />
                      ) : (
                        "Download PDF"
                      )}
                    </button>
                    <button
                      onClick={this.generateXLSX}
                      className="item itemSelected"
                      disabled={this.state.disableDownload1}
                    >
                      {this.state.disableDownload1 ? (
                        <span className="spinner" />
                      ) : (
                        "Download XLSX"
                      )}
                    </button>
                  </div>

                  <SlideOver
                    setOpen={this.setOpen}
                    open={this.state.open}
                    item={this.state.item}
                  />
                  <Table
                    list={this.state.filteredList}
                    setOpen={this.setOpen}
                  />

                  <div className="pagination">
                    <button
                      disabled={this.state.currentPage === 1}
                      onClick={() => {
                        const that = this;
                        this.setState(
                          { currentPage: Number(this.state.currentPage) - 1 },
                          () => that.refresh(),
                        );
                      }}
                    >
                      {this.state.translations.previous}
                    </button>
                    <span>
                      {this.state.translations.page}
                      <input
                        type="number"
                        value={this.state.currentPage}
                        onChange={(e) =>
                          this.setState({ currentPage: e.target.value })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            this.updateCurrentPage(e.target.value);
                          }
                        }}
                        className="inputPage"
                      />
                    </span>
                    <button
                      onClick={() => {
                        const that = this;
                        this.setState(
                          { currentPage: Number(this.state.currentPage) + 1 },
                          () => that.refresh(),
                        );
                      }}
                    >
                      {this.state.translations.next}
                    </button>
                  </div>
                </div>

                <Footer />
              </div>
            </div>
          </span>
        )}
        <ToastContainer />
      </section>
    );
  }
}

export default Item;
